<script lang="ts">
	import { Heading, Input } from "flowbite-svelte";
	import { twMerge } from "tailwind-merge";
	import type { Form } from "#gen/forms/v1/forms_pb.js";
	import P from "#lib/components/P.svelte";

	interface Props {
		form: Form;
		onInput?: (form: Form) => void;
		onChange?: (form: Form) => void;
	}

	let { form = $bindable(), onInput, onChange }: Props = $props();

	function handleInput(e: Event) {
		const input = e.target as HTMLInputElement;
		if (input.value.length > 0) {
			form.actionText = input.value;
		} else {
			form.actionText = undefined;
		}
		onInput?.(form);
	}

	function handleChange(_e: Event) {
		onChange?.(form);
	}
</script>

<div class="flex flex-col gap-4 pt-6">
	<div class="flex items-start gap-4">
		<div class="flex grow flex-col gap-1">
			<Heading tag="h2" class="grow text-lg font-semibold">Settings</Heading>
			<P size="sm" secondary>Configure additional information about this form.</P>
		</div>
	</div>
	<div tabindex="-1" class={twMerge("rounded-lg border bg-white py-6 pr-16 pl-12")}>
		<label for="actionText" class="mb-2 inline-block text-sm font-medium">Form submit button</label>
		<Input type="text" name="actionText" id="actionText" placeholder="Submit" value={form.actionText} on:input={handleInput} on:change={handleChange} />
	</div>
</div>
